
let sInstance = null;

class PersistStore   {

	constructor() {
		// console.log("PersistStore: constructor");
		
		this.iStorage = null;
	}

	static getInstance() {
		if (!sInstance) {
            // console.log('PersistStore: Returning a new instance for PersistStore');
            sInstance = new PersistStore();
        }

        
        // console.log('PersistStore: Returned an already created instance for PersistStore')
        return sInstance;
	}

	initWithStorage(aStorage) {

		//Store the pointer to the localStorage

		this.iStorage = aStorage;
	}


	createPersistObject(aObjectName) {

		// Check whether it exists

		if (this.iStorage.getItem(aObjectName) ) {
			// console.log('The object ' + aObjectName + ' exists in the store')
			return;
		}

		// Create an empty object for the given store
		// console.log('Creating the object ' + aObjectName + ' as empty');
		this.iStorage.setItem(aObjectName, JSON.stringify({}));

		return;
	}

	getPersistObject(aObjectName) {

		// Get the object associated with the given name

		let lObjectString = this.iStorage.getItem(aObjectName);
		return JSON.parse(lObjectString);
	}

	updatePersistObject(aObjectName, aObject) {

		// Update the value for given name

		this.iStorage.setItem(aObjectName, JSON.stringify(aObject));
	}


	deletePersistObject(aObjectName) {

		// Delete the storage associated with the Object

		this.iStorage.removeItem(aObjectName);
	}
};

let lInstance = PersistStore.getInstance();


export default lInstance;


// WEBPACK FOOTER //
// ./src/lib/policymanager/persistStore.js